<div *ngIf="hostingPlatform">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>class</mat-icon>
      {{
        hostingPlatform.id ? "Hosting Platform - " + hostingPlatform.name : "Create new Hosting Platform"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ hostingPlatform.id ? "save" : "add" }}</mat-icon>
        {{ hostingPlatform.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="hostingPlatform.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Hosting Platform Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="hostingPlatform.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="hostingPlatform.code"
                required
                maxlength="10"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="hostingPlatform.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="hostingPlatform.description"
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="hostingPlatform.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="hostingPlatform.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>          
        </tbody>
      </table>
    </form>
  </div>
</div>
